import Config from '../config/Config'
import axios from 'axios'
import { setupAxiosOktaInterceptors } from '../config/AxiosInterceptors'
import { RebookingHistoryResponse } from '../common/hooks/useRebookingHistory'

export const rebookingServiceClient = setupAxiosOktaInterceptors(
  axios.create({
    baseURL: `${Config.REBOOKING_SERVICE_URL}`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
)

export const fetchRebookingHistory = async (
  shipmentReference: string
): Promise<RebookingHistoryResponse[]> => {
  return rebookingServiceClient
    .get(`/rebooking/v1/history/${encodeURIComponent(shipmentReference)}`)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.status === 404)
        // treat this as success and return an empty rebooking history response array
        return []
    })
}
